import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./LoginSlice";
import profileReducer from "./ProfileSlice";
import KycsReducer from './KycsSlice';
import InitiatepayoutReducer from './InitiatepayoutSlice'
import Dashboard from "../redux/DashbordSlice";

const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem("reduxState");
    if (serializedState) {
      return JSON.parse(serializedState);
    }
  } catch (err) {
    console.error("Could not load state from sessionStorage", err);
  }
  return undefined;
};
  
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem("reduxState", serializedState);
  } catch (err) {
    console.error("Could not save state to sessionStorage", err);
  }
};

const persistedState = loadState();

const store = configureStore({
  reducer: {
    login: loginReducer,
    profile: profileReducer,
    kycs_details: KycsReducer,
    Initiatepayout: InitiatepayoutReducer,
    Dashboard:Dashboard
  },
});

store.subscribe(() => {
    saveState(store.getState());
  });

export default store;